import React from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle, ExternalLink } from "lucide-react";

export default function KnowledgeBaseDocGapWarning({ gaps }) {
    const { t } = useTranslation();

    if (!gaps || !gaps.length) return null;

    return (
        <div className="border border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-700 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
                <AlertTriangle className="w-5 h-5 text-amber-600" />
                <h3 className="text-sm font-semibold text-amber-800 dark:text-amber-300">
                    {t("admin.support.docGapWarning", "{{count}} Unresolved Documentation Gaps", { count: gaps.length })}
                </h3>
            </div>
            <p className="text-xs text-amber-700 dark:text-amber-400 mb-3">
                {t("admin.support.docGapWarningDesc", "These topics were asked about but have no documentation coverage.")}
            </p>
            <div className="space-y-1.5">
                {gaps.slice(0, 10).map((gap) => (
                    <div key={gap.id} className="flex items-center gap-2 text-sm">
                        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 flex-shrink-0" />
                        <span className="flex-1 truncate text-amber-900 dark:text-amber-200">{gap.query}</span>
                        {gap.ticket && (
                            <a href={`/admin/support/${gap.ticket.id}`}
                                className="flex items-center gap-0.5 text-xs text-amber-600 hover:underline flex-shrink-0">
                                <ExternalLink className="w-3 h-3" />
                                {gap.ticket.subject?.slice(0, 25)}
                            </a>
                        )}
                    </div>
                ))}
                {gaps.length > 10 && (
                    <p className="text-xs text-amber-600 mt-1">
                        {t("admin.support.moreGaps", "+{{count}} more", { count: gaps.length - 10 })}
                    </p>
                )}
            </div>
        </div>
    );
}
